import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction, userInfoSlice } from '!core/redux';
import { isTodayAfterGivenDate, isWithinDaysAfterToday } from '»utils/date';

export const initialState = {
  initialText: '',
  currentStep: 1,
  surveyId: 0,
  isDirty: false,
  shouldShowAlmostExpQuestAlert: false,
  shouldShowExpQuestAlert: false,
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

export const questionnaireSlice = createSlice({
  name: 'questionnaireSlice',
  initialState,
  reducers: {
    getQuestionnaireRequest: (state) => state,
    getQuestionnaireSuccess: (state, action) => {
      const { questions, initialText, surveyId } = action.payload;
      state.questions = questions;
      state.initalText = initialText.replace(/<[^>]+>/g, '');
      state.surveyId = surveyId;
    },
    getQuestionnaireFailure: (state) => state,
    setQuestionnaireCurrentStep: (state, action) => {
      const { direction } = action.payload;
      if (!state.isDirty) {
        state.isDirty = true;
      }
      state.currentStep =
        direction === 'forward' ? state.currentStep + 1 : state.currentStep - 1;
    },
    submitQuestionnaireAnswersRequest: (state) => state,
    submitQuestionnaireAnswersSuccess: (state, action) => {
      state.answers = action.payload.answers;
    },
    submitQuestionnaireAnswersFailure: (state) => state,
    hideQuestAlert: (state) => {
      state.shouldShowAlmostExpQuestAlert = false;
      state.shouldShowExpQuestAlert = false;
    },
    clearQuestionnaire: clearState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState)
      .addCase(userInfoSlice.actions.userInfoSucess, (state, action) => {
        const { questExpirationDate } = action.payload[0];

        if (
          questExpirationDate &&
          isWithinDaysAfterToday(questExpirationDate, 7)
        ) {
          state.shouldShowAlmostExpQuestAlert = true;
        } else if (
          questExpirationDate &&
          isTodayAfterGivenDate(questExpirationDate)
        ) {
          state.shouldShowExpQuestAlert = true;
        }
      });
  },
});
